<div class="user-organization-general-information">
    <div hidden class="edit-organization-profile-picture">
        <img
            class="organization-profile-image"
            src="https://a57.foxnews.com/media2.foxnews.com/BrightCove/694940094001/2018/06/21/931/524/694940094001_5800293009001_5800284148001-vs.jpg?ve=1&tl=1"
            alt="profile-image"
        />
        <div hidden class="image-black-circle" (click)="updateOrganizationProfilePicture()">
            <div class="edit-image-container">
                <mat-icon svgIcon="aumico-users-icon-edit-image"></mat-icon>
            </div>
        </div>
    </div>
    <div class="form-row">
        <div class="form-col form-contaier">
            <div [formGroup]="organizationProfileFormGroup" class="edit-organization-profile-form form-container">
                <span class="aum-typo-paragraph-l">
                    {{ 'aumico_users_edit_user_company_general_information_edit_your_profile' | i18next  }}
                </span>

                <div class="form-row">
                    <aum-input
                        placeholder="{{
                            'aumico_users_edit_user_company_general_information_enter_name' | i18next 
                        }}"
                        [aumFormControl]="organizationProfileFormGroup.controls['name']"
                    >
                        <aum-form-field-label>{{
                            'aumico_users_edit_user_company_general_information_name' | i18next 
                        }}</aum-form-field-label>
                    </aum-input>
                </div>
                <div class="form-row">
                    <aum-input
                        placeholder="{{
                            'aumico_users_edit_user_company_general_information_enter_street' | i18next 
                        }}"
                        [aumFormControl]="organizationProfileFormGroup.controls['street']"
                    >
                        <aum-form-field-label>{{
                            'aumico_users_edit_user_company_general_information_street' | i18next 
                        }}</aum-form-field-label>
                    </aum-input>
                    <aum-input
                        class="form-field-margin small"
                        placeholder="{{
                            'aumico_users_edit_user_company_general_information_enter_no' | i18next 
                        }}"
                        [aumFormControl]="organizationProfileFormGroup.controls['streetNumber']"
                    >
                        <aum-form-field-label>{{
                            'aumico_users_edit_user_company_general_information_no' | i18next 
                        }}</aum-form-field-label>
                    </aum-input>
                </div>
                <div class="form-row">
                    <aum-input
                        class="large"
                        placeholder="{{
                            'aumico_users_edit_user_company_general_information_address_addition' | i18next 
                        }}"
                        [aumFormControl]="organizationProfileFormGroup.controls['additionToAddress']"
                    >
                        <aum-form-field-label>{{
                            'aumico_users_edit_user_company_general_information_address_addition' | i18next 
                        }}</aum-form-field-label>
                    </aum-input>
                </div>
                <div class="form-row">
                    <aum-input
                        class="small"
                        placeholder="{{
                            'aumico_users_edit_user_company_general_information_enter_zip' | i18next 
                        }}"
                        [aumFormControl]="organizationProfileFormGroup.controls['zip']"
                    >
                        <aum-form-field-label>{{
                            'aumico_users_edit_user_company_general_information_zip' | i18next 
                        }}</aum-form-field-label>
                    </aum-input>
                    <aum-input
                        class="form-field-margin three-quarter-width"
                        placeholder="{{
                            'aumico_users_edit_user_company_general_information_enter_city' | i18next 
                        }}"
                        [aumFormControl]="organizationProfileFormGroup.controls['city']"
                    >
                        <aum-form-field-label>{{
                            'aumico_users_edit_user_company_general_information_city' | i18next 
                        }}</aum-form-field-label>
                    </aum-input>
                </div>
                <div class="form-row"></div>

                <aum-select
                    class="full-width"
                    placeholder="{{
                        'aumico_users_edit_user_company_general_information_choose_country' | i18next 
                    }}"
                    [options]="countryOptionsList"
                    [aumFormControl]="organizationProfileFormGroup.controls['country']"
                >
                    <aum-form-field-label>
                        {{ 'aumico_users_edit_user_company_general_information_country' | i18next  }}
                    </aum-form-field-label>
                </aum-select>
            </div>
        </div>
        <div class="form-col form-contaier">
            <div class="file-upload section-detail">
                <span class="aum-typo-paragraph-l">
                    {{ 'aumico_users_edit_user_company_general_information_company_logo' | i18next  }}
                </span>
                <aumico-file-upload
                    [tint]="true"
                    [accept]="accept"
                    [currentFileName]="logo ? logo.name : null"
                    [instructionLabelKey]="'aumico_users_edit_user_company_general_information_upload_logo_label'"
                    [instructionTextKey]="'aumico_users_edit_user_company_general_information_upload_logo_text'"
                    [extensionErrorKey]="
                        'aumico_users_edit_user_company_general_information_upload_logo_extension_error'
                    "
                    (fileChange)="onOrganizationLogoFileChange($event)"
                >
                </aumico-file-upload>

                <div *ngIf="logo == null" class="aum-typo-paragraph-xs aum-typo-strong side-margins">
                    {{ 'aumico_users_company_profile_general_information_side_margins' | i18next  }}
                </div>
            </div>
        </div>
    </div>
</div>
